import { render, staticRenderFns } from "./interdict.vue?vue&type=template&id=10959704&scoped=true&"
import script from "./interdict.vue?vue&type=script&lang=js&"
export * from "./interdict.vue?vue&type=script&lang=js&"
import style0 from "./interdict.vue?vue&type=style&index=0&id=10959704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10959704",
  null
  
)

export default component.exports